import { render, staticRenderFns } from "./ViewForm.vue?vue&type=template&id=ed48ffe6&scoped=true"
import script from "./ViewForm.vue?vue&type=script&lang=js"
export * from "./ViewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed48ffe6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed48ffe6')) {
      api.createRecord('ed48ffe6', component.options)
    } else {
      api.reload('ed48ffe6', component.options)
    }
    module.hot.accept("./ViewForm.vue?vue&type=template&id=ed48ffe6&scoped=true", function () {
      api.rerender('ed48ffe6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/stock/distribution/plan/components/ViewForm.vue"
export default component.exports